// Department
export const apiGetList = `Department/GetList`
export const apiGetListUserByDept = `Department/ListUserByDept`
export const apiDeleteDept = `Department/DeleteDept`
export const apiInsertUpdate = `Department/InsertUpdate`
export const apiGetAllDept = "Department/GetAllForCombobox"

// CATEFORY_POST

export const apiGetListCategoryPost = "CategoryPost/GetList"
export const apiSortCategories = "CategoryPost/SortCategories"

export const apiInsertCategory = "CategoryPost/Insert"
export const apiUpdateCategory = "CategoryPost/Update"
export const apiDeleteCategory = "CategoryPost/Delete"

// POST

export const apiGetListPost = "Post/GetList"
export const apiInsertPost = "Post/Insert"
export const apiGetDetailPost = "Post/GetDetail"
export const apiUpdatePost = "Post/Update"
export const apiDeletePost = "Post/Delete"
export const apiRePost = "Post/RePost"
export const apiCancelPost = "Post/CancelPost"
export const apiSortPost = "Post/SortPost"
export const apiKhoiPhuc = "Post/KhoiPhuc"
export const apiGetListHistory = "Post/GetListHistory"
export const apiGetDetailHistory = "Post/GetDetailHistory"
export const apiUpdateStatusPost = "Post/UpdateStatusPost"
export const apiExportPost = "Post/ExportPost"

// Role
export const apiGetByRoleId = `Role/GetByRoleId`
export const apiCreateOrUpdateRole = `Role/CreateOrUpdateRole`
export const apiGetListRole = `Role/GetList`
export const apiGetAllForCombobox = `Role/GetAllForCombobox`
export const apiDeleteRole = `Role/DeleteRole`
export const apiGetListTab = `Role/GetListTab`
export const apiGetListTask = `Role/GetListTask`

// TAGS
export const apiGetListTags = "Tags/GetList"
export const apiInsertTags = "Tags/Insert"
export const apiUpdateTags = "Tags/Update"
export const apiDeleteTags = "Tags/Delete"
export const apiGetAllTags = "Tags/GetAllForCombobox"

export const apiGetListTagsQuestions = "Tags/GetListTagCoure"
export const apiInsertTagsQuestions = "Tags/InsertTagCoure"
export const apiUpdateTagsQuestions = "Tags/UpdateTagCoure"
export const apiDeleteTagsQuestions = "Tags/DeleteTagCoure"
export const apiGetAllTagsQuestions = "Tags/GetAllForComboboxTagCoure"

//Contact
export const apiSearchGetSupportListRequet =
  "Contact/SearchGetSupportListRequet"
export const apiStatusSupport = "Contact/StatusSupport"
export const apiGetDetailContact = "Contact/GetDetailContact"
export const apiSendContact = "Contact/SendContact"

//PostComment
export const apiPostCommentInsert = "PostComment/PostCommentInsert"
export const apiPostCommentUserLike = "PostComment/PostCommentUserLike"
export const apiPostCommentDelete = "PostComment/PostCommentDelete"
export const apiPostCommentUpdate = "PostComment/PostCommentUpdate"
export const apiGetAllPostCommnetByType = "PostComment/GetAllPostCommnetByType"

//Career-Field
export const apiGetListCareer = "Career/GetListCareer"
export const apiInsertCareer = "Career/InsertCareer"
export const apiUpdateCareer = "Career/UpdateCareer"
export const apiDeleteCareer = "Career/DeleteCareer"
//
export const apiGetListField = "Career/GetListField"
export const apiInsertField = "Career/InsertField"
export const apiUpdateField = "Career/UpdateField"
export const apiDeleteField = "Career/DeleteField"

//Directory
export const apiGetAllUserDirectory = "Directory/GetAllUserDirectory"
export const apiInsertUserDirectory = "Directory/InsertUserDirectory"
export const apiUpdateUserDirectory = "Directory/UpdateUserDirectory"
export const apiDeleteUserDirectory = "Directory/DeleteUserDirectory"
export const apiBlockUserDirectory = "Directory/BlockUserDirectory"
export const apiResetPasswordByUserID = "Directory/ResetPasswordByUserID"

//Banner && Footer
export const apiGetListBannerFooter = `BannerFoodter/GetList`
export const apiInsertBannerFooter = `BannerFoodter/Insert`
export const apiUpdateBannerFooter = `BannerFoodter/Update`
export const apiGetListEvent = `BannerFoodter/GetListEvent`
export const apiInsertEvent = `BannerFoodter/InsertEvent`
export const apiUpdateEvent = `BannerFoodter/UpdateEvent`
export const apiDeleteEvent = `BannerFoodter/DeleteEvent`
export const apiUpdateOrderEvent = `BannerFoodter/UpdateOrderEvent`

//Payment
export const apiGetAllTransactionID = `Payment/GetAllTransactionID`
export const apiTopUpAccount = `Payment/TopUpAccount`
export const apiHistoryRecharge = `Payment/HistoryRecharge`
export const apiInforPayment = `Payment/InforPayment`

//Question
export const apiGetListQuestionForLession = `Question/GetListQuestionForLession`
export const apiInsertQuestion = `Question/InsertQuestion`
export const apiUpdateQuestion = `Question/UpdateQuestion`
export const apiDeleteQuestion = `Question/DeleteQuestion`
export const apiScoring = `Question/Scoring`
export const apiUploadFileTest = `Question/UploadFileTest`
export const apiUploadFileTestExcel = `Question/UploadFileTestExcel`
export const apiGetListQuestionParent = `Question/GetListQuestionParent`
export const apiInsertQuestionParent = `Question/InsertQuestionParent`
export const apiUpdateQuestionParent = `Question/UpdateQuestionParent`
export const apiDeleteQuestionParent = `Question/DeleteQuestionParent`
export const apiGetAllTestDoneForLesson = `Question/GetAllTestDoneForLesson`
export const apiUpdateScoreForTestByUser = `Question/UpdateScoreForTestByUser`
//Question Bank
export const apiGetListQuestionBank = `Question/GetListQuestionBank`
export const apiInsertQuestionBank = `Question/InsertQuestionBank`
export const apiUpdateQuestionBank = `Question/UpdateQuestionBank`

//OverView
export const apiGetOverView = `OverView/GetList`
//Students
export const apiGetStudentsList = `User/GetAllStudent`
export const apiSaveTestForUserByLesson = `Question/SaveTestForUserByLesson`
